import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import AppEntrySection from './components/AppEntrySection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import FAQSection from './components/FAQSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <AppEntrySection />
        <AboutSection />
        <FeaturesSection />
        <ContactSection />
        <IndexSection />
        <RankingSection />
        <CommentsSection />
        <UpdatesSection />
        <FAQSection />
        <MediaSection />
        <CarouselSection />
        <CardsSection />
      </main>
      <Footer />
    </div>
  );
}